exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".togglePrevious {\n  padding-top: 20px !important;\n}\n.set-rates-button {\n  padding-right: 10px !important;\n  padding-left: 10px;\n  padding-top: 34px;\n}\n.reset-rates-button {\n  padding-top: 34px;\n}\n.alt-fiscal-year {\n  padding-left: 14px;\n}\n.site-dropdown {\n  padding-top: 5px;\n}\n.site-label {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  font-weight: 'Bold';\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/provision2baseratessetup/provision2style.less
// module id = 3946
// module chunks = 0